const skills = [
    {
        title: 'DEVELOPPEMENT WEB',
        skills: ['HTML5', 'CSS3', 'SASS', 'Mobile First', 'WordPress'],
    },
    {
        title: 'DEVELOPPEMENT',
        skills: ['ReactJS', 'API', 'JavaScript', 'GitHub', 'SQL'],
    },
    {
        title: 'GESTION DE PROJET',
        skills: [
            'Figma',
            'Spéc techniques',
            'Kanban',
            'Veille',
            'SAP S/4Hana',
            'Infor M3',
            'Formation ERP',
        ],
    },
    {
        title: 'REFERENCEMENT',
        skills: ['SEO', 'Lighthouse', 'Search Console', 'Wave'],
    },

    {
        title: 'PERFORMANCE ACHATS',
        skills: [
            'Achats',
            'Reporting',
            "Appels d'offres",
            'Suivi fournisseurs',
        ],
    },
];

export default skills;
